import { render, staticRenderFns } from "./o-features.vue?vue&type=template&id=6f1401e9&scoped=true"
import script from "./o-features.vue?vue&type=script&lang=js"
export * from "./o-features.vue?vue&type=script&lang=js"
import style0 from "./o-features.vue?vue&type=style&index=0&id=6f1401e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1401e9",
  null
  
)

export default component.exports